import React from 'react';
import PropTypes from 'prop-types';
import Avatar from 'components/shared/avatar/component';
import clsx from 'clsx';
PaymentAvatar.propTypes = {
    thumbnail: PropTypes.string,
    name: PropTypes.string,
    avatarPosition: PropTypes.string,
    payeeString: PropTypes.string,
    addedClasses: PropTypes.string
};
export default function PaymentAvatar(_a) {
    var _b = _a.thumbnail, thumbnail = _b === void 0 ? '' : _b, _c = _a.name, name = _c === void 0 ? '' : _c, _d = _a.avatarPosition, avatarPosition = _d === void 0 ? '' : _d, _e = _a.payeeString, payeeString = _e === void 0 ? '' : _e, _f = _a.addedClasses, addedClasses = _f === void 0 ? '' : _f;
    return (React.createElement("div", { className: clsx(['payee', 'text-align-center', addedClasses]) },
        React.createElement("div", { className: "payee__icon" },
            React.createElement("div", { className: "payee-icon__inner" },
                React.createElement(Avatar, { src: thumbnail, position: avatarPosition, addedClasses: "green-borders" }))),
        React.createElement("div", { className: "payee__profile" },
            React.createElement("div", { className: "payee__name" }, name),
            React.createElement("div", { className: "payee__role" }, payeeString))));
}
